import {
  GoogleAuthProvider,
  isSignInWithEmailLink,
  signInWithEmailLink,
  signInWithPopup,
  FacebookAuthProvider,
  onAuthStateChanged as _onAuthStateChanged,
  sendSignInLinkToEmail as _sendSignInLinkToEmail,
  RecaptchaVerifier,
  signInWithPhoneNumber as _signInWithPhoneNumber,
  ConfirmationResult,
  updatePhoneNumber,
  User,
  PhoneAuthProvider,
  reauthenticateWithCredential,
  EmailAuthProvider,
  setPersistence,
  browserSessionPersistence,
  OAuthProvider,
} from "firebase/auth";
import { auth } from "./firebase";

// export function onAuthStateChanged(cb?: any) {
//   return _onAuthStateChanged(auth, cb);
// }

export async function signInWithGoogle(success?: any) {
  const provider = new GoogleAuthProvider();
  provider.setCustomParameters({
    prompt: "select_account",
  });
  try {
    await signInWithPopup(auth, provider)
      .then((result) => {
        success(result);
      })
      .catch((error) => {
        // Handle Errors here.
        const errorCode = error.code;
        const errorMessage = error.message;
      });
  } catch (error) {
    console.error("Error signing in with Google", error);
  }
}

export async function signInWithApple(success?: any) {
  const provider = new OAuthProvider('apple.com');

  try {
    await signInWithPopup(auth, provider)
      .then((result) => {
        success(result);
      })
      .catch((error) => {
        // Handle Errors here.
        const errorCode = error.code;
        const errorMessage = error.message;
      });
  } catch (error) {
    console.error("Error signing in with Google", error);
  }
}

export async function sendSignInLinkToEmail(
  email: string,
  redirectUrl: string
) {
  try {
    await _sendSignInLinkToEmail(auth, email, {
      url: redirectUrl,
      handleCodeInApp: true,
    });
    return true;
  } catch (e) {
    return false;
  }
}

export function signInEmailLink(
  email: string,
  successFn: (success: any) => void,
  errorFn: (error: any) => void
) {
  try {
    if (isSignInWithEmailLink(auth, window.location.href)) {
      signInWithEmailLink(auth, email, window.location.href)
        .then((result) => {
          successFn(result);
        })
        .catch((err) => {

          errorFn(err);
        });
    }
  } catch (error) {
    console.error("Error signing in with Email Link", error);
  }
}

export async function sendOTPToPhoneForSignIn(
  mobile: string,
  appVerifier: RecaptchaVerifier
): Promise<ConfirmationResult | undefined> {
  try {
    return await _signInWithPhoneNumber(auth, mobile, appVerifier);
  } catch (e) {
    console.error("Error signing in with Phone", e);
  }
}

export async function signInWithPhoneNumber(
  confirmationResult: ConfirmationResult,
  otp: string
) {
  try {
    return await confirmationResult.confirm(otp);
  } catch (e) {
    console.error("Error signing in with Phone", e);
  }
}

export function getFirebaseAuthRecaptchaVerifier() {
  return new RecaptchaVerifier(auth, "recaptcha-container", {
    size: "invisible",
  });
}

export async function signInWithFacebook() {
  const provider = new FacebookAuthProvider();
  try {
    signInWithPopup(auth, provider)
      .then((result) => {
        // The signed-in user info.
      })
      .catch((error) => {
        console.error("Error signing in with Facebook", error);
      });
  } catch (error) {
    console.error("Error signing in with Google", error);
  }
}

export const getURLWithQueryParams = (base: any, params: any) => {
  // 
  const query = Object.entries(params)
    .map(([key, value]: any) => `${key}=${encodeURIComponent(value)}`)
    .join("&");

  return `${base}?${query}`;
};

export async function signInWithLinkedInUrl() {
  const provider = new OAuthProvider("oidc.linkedin");
  provider.addScope("email");
  provider.addScope("profile");

  try {
    const result = await signInWithPopup(auth, provider);
    return result;
  } catch (error) {
    console.error("Error signing in with LinkedIn", error);
  }
}

export async function verifyNewPhoneNumber(phoneNumber: string) {
  const applicationVerifier = getFirebaseAuthRecaptchaVerifier();
  const provider = new PhoneAuthProvider(auth);
  return provider.verifyPhoneNumber(phoneNumber, applicationVerifier);
}

export async function updateAuthUserPhoneNumber(
  user: User,
  verificationId: string,
  verificationCode: string
) {
  const credentials = PhoneAuthProvider.credential(
    verificationId,
    verificationCode
  );
  return updatePhoneNumber(user, credentials);
}

export async function reauthenticateWithEmailLink(
  user: User,
  currentUrl: string
) {
  if (!user.email) return;
  try {
    const credential = EmailAuthProvider.credentialWithLink(
      user.email,
      currentUrl
    );
    await reauthenticateWithCredential(user, credential);
  } catch (e) {


  }
}

export async function signOut() {
  try {
    return auth.signOut();
  } catch (error) {
    console.error("Error signing out with Google", error);
  }
}
